import { ADD_TO_LIST_DETAILS } from './types';


export const addToListDetailsAction = (product) => dispatch => {
    console.log('product inside addToListDetailsAction...', product);
    dispatch({
        type: ADD_TO_LIST_DETAILS,
        product: product
   
    })
}
